import { useParams } from '@redwoodjs/router'
import { MetaTags } from '@redwoodjs/web'

import PartCell from "src/components/PartCell"

import { rwUrlDecode } from 'src/lib/util';

const PartPage = () => {
  // no links use branch but it's useful
  const { partNumber, version, orderNumber } = useParams();
  const n = rwUrlDecode(decodeURI(partNumber));
  const v = version ? rwUrlDecode(decodeURI(version)) : undefined;
  return (
    <>
      <MetaTags title={"#" + n} description="Part page" />
      <div className='pt-6 px-6 max-w-[1200px] mx-auto'>
        <PartCell partNumber={n} version={v} orderNumber={Number(orderNumber)} />
      </div>
    </>
  )
}

export default PartPage
